import React from "react";
import { type NextPage } from "next";
import { Page } from "components/page";
import { getLandingPageProps, getPageMetaImage, type LandingPageProps } from "utils";
import { StackedLogos } from "components/logos";
import { sectionSpacingY } from "components/section";
import {
  IdrHero,
  IdentitiesExplainer,
  IdrProductFeatures,
  IdrMatching,
  IdrCdpAccordion,
} from "components/platform/identity-resolution";
import { DestinationMarquee, SecurityFeatures } from "components/content";
import { SolidPlate } from "ui/plates";

const IdentityResolution: NextPage<LandingPageProps> = ({
  page,
  announcementBanner,
  destinations,
  defaultLogos,
  defaultMobileLogos,
}) => {
  return (
    <Page
      theme="light"
      bgColor="new.blue.150"
      title={page.metaTitle}
      description={page.metaDescription}
      image={getPageMetaImage({ src: page.metaImageUrl, alt: page.metaTitle })}
      announcementBanner={announcementBanner}
      footerOptions={{ variant: "blue" }}
    >
      <IdrHero eyebrow={page.eyebrow} title={page.title} description={page.description} />

      <StackedLogos
        customers={defaultLogos}
        mobileCustomers={defaultMobileLogos}
        my="0"
        mt={{ base: "0", md: "huge" }}
        pb={{ base: "biggest", md: "huger" }}
      />

      <SolidPlate theme="dark" bgColor="new.blue.950" spotlightColor="new.blue.900">
        <IdrMatching />
        <IdentitiesExplainer />
      </SolidPlate>

      <IdrProductFeatures />

      <SolidPlate theme="dark" bgColor="new.blue.900">
        <IdrCdpAccordion />
        <SecurityFeatures
          noContainerPx
          theme="dark"
          themeBgColor="new.blue.900"
          my="0"
          mt={{ base: "huge", md: "huger" }}
        />
      </SolidPlate>

      <DestinationMarquee destinations={destinations} my={0} py={sectionSpacingY} />
    </Page>
  );
};

export default IdentityResolution;

export const getStaticProps = getLandingPageProps("/platform/identity-resolution", {
  loadDefaultLogos: true,
  loadDefaultMobileLogos: true,
  loadDestinations: "all",
});
